export const DISABLE_COLOR = '#bdbdbd'
